import React, { Fragment } from 'react';
import I18n from '../../config/locales/e_i18n';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import queryString from 'query-string';
import { DefaultHeader } from '../../components/common/Header';
import { Footer } from '../../components/common/Footer';
import {
  forwardTo,
  setToken,
  decodeToken,
  getToken,
  handleFeedbackMenu,
  getBelongsTo,
  constructQueryString
} from '../../utils/helper';
import { get } from '../../utils/lodash';
import { setCompanyId, setMobileView, setIsAdmin } from './actions';
import { getAccountData } from '../AccountDetails/actions';
import Loader from '../../components/Loader';
import Breadcrumbs from '../../components/common/Breadcrumbs';
import getMoment from '../../components/common/moment';
import analytics from '../../utils/analytics';
import GoogleAnalytics from '../../utils/GoogleAnalytics/googleAnalytics4';
import settings from '../../utils/settings';

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5)
  },
  body: {
    marginTop: theme.spacing(7)
  },
  mobileBody: {
    marginTop: theme.spacing(5.5)
  }
}));

const Layout = ({
  children,
  isMobileView,
  currentlySending,
  isAdmin,
  matchProps,
  accountDetail,
  companyId,
  isUnauthorized,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <Fragment>
      <DefaultHeader isAdmin={isAdmin} {...matchProps} />
      {currentlySending || isUnauthorized ? (
        <Loader loading />
      ) : (
        <Box className={isMobileView ? classes.mobileBody : classes.body}>
          <Breadcrumbs matchProps={matchProps} />
          {currentlySending && <Loader loading={currentlySending} />}
          <Box className={classes.root}>{children}</Box>
        </Box>
      )}
      <Footer />
    </Fragment>
  );
};

class DefaultLayout extends React.Component {
  constructor(props) {
    super(props);
    const { search, pathname } = props.location;
    const { token, ...remainingQuery } = queryString.parse(search);
    this.isAdmin = get(remainingQuery, 'isAdmin', false) || false;
    const { company_id } = this.getCompanyUserId(token, pathname);
    const { is_distributor } = this.getIsDistributor(token, pathname);
    const companyIdFromParam = get(props, 'computedMatch.params.companyId');
    const companyId = companyIdFromParam ? companyIdFromParam : company_id;
    if (token && pathname) {
      setToken(token);
      const queryString = constructQueryString(remainingQuery);
      const forwardPathname = `${pathname}${queryString}`;
      forwardTo(forwardPathname);
    }

    if (is_distributor && !pathname.includes('/manager/dashboard/account-details') && !pathname.includes('/manager/dashboard/error')){
      window.location = '/manager/dashboard/distributor-dashboard';
    }
    
    if (companyId) {
      this.props.setCompanyId(companyId);
      this.props.getAccountData({ successCbk: () => this.accountSuccessCbk(companyId) });
    }
    const googleAnalytics =new GoogleAnalytics()
    const environments= settings.getConfig()
    googleAnalytics.setEnvironment(environments.env)
    this.analytics = new analytics();
    window.analytics = this.analytics;
  }

  UNSAFE_componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  accountSuccessCbk = companyId => {
    const { accountDetail } = this.props;
    const installerName = get(accountDetail, 'first_name', '') + ' ' + get(accountDetail, 'last_name', '');
    this.analytics.setUserId(accountDetail.user_id, installerName, companyId);
  };

  getCompanyUserId = (token = '') => {
    const tokenValue = token || getToken();
    const { company_id } = decodeToken(tokenValue);
    return { company_id };
  };

  getIsDistributor = (token = '') => {
    const tokenValue = token || getToken();
    const { is_distributor } = decodeToken(tokenValue);
    return { is_distributor };
  };

  handleWindowSizeChange = () => {
    const isMobileView = window.innerWidth <= 1200;
    this.props.setMobileView(isMobileView);
  };

  componentDidUpdate = prevProps => {
    handleFeedbackMenu(this.props);
    I18n.defaultLocale = 'en';
    I18n.locale = this.props.locale || '';
    I18n.fallbacks = true;
    getBelongsTo(this.props.countryCode);
    getMoment(this.props.locale);
  };

  componentDidMount = () => {
    this.handleWindowSizeChange();
    if (this.props.isAdmin || this.isAdmin === 'true') {
      this.props.setIsAdmin(true);
    } else {
      this.props.setIsAdmin(false);
      const pathName = window.location.pathname;
      const splitPathName = pathName.split('/');
      const pathArray = [];
      splitPathName.forEach(path => path && pathArray.push(path));
      if (pathArray[pathArray.length - 1] !== 'account') {
        window.location = '/manager/account';
      }
    }
  };

  render() {
    const {
      component: Component,
      isMobileView,
      currentlySending,
      isAdmin,
      accountDetail,
      companyId,
      isUnauthorized,
      ...rest
    } = this.props;
    return (
      <Route
        {...rest}
        render={matchProps => (
          <Layout
            isMobileView={isMobileView}
            currentlySending={currentlySending}
            isAdmin={isAdmin}
            companyId={companyId}
            matchProps={matchProps}
            accountDetail={accountDetail}
            isUnauthorized={isUnauthorized}
          >
            <Component {...matchProps} />
          </Layout>
        )}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setCompanyId: companyId => dispatch(setCompanyId(companyId)),
  setIsAdmin: isAdmin => dispatch(setIsAdmin(isAdmin)),
  getAccountData: payloads => dispatch(getAccountData(payloads)),
  setMobileView: isMobileView => dispatch(setMobileView(isMobileView))
});

const mapStateToProps = state => ({
  isMobileView: state.appReducer.isMobileView,
  companyId: state.appReducer.companyId,
  isAdmin: state.appReducer.isAdmin,
  currentlySending: state.accountReducer.currentlySending,
  accountDetail: state.accountReducer.accountDetail,
  isUnauthorized: state.accountReducer.isUnauthorized,
  locale: state.accountReducer.locale,
  countryCode: state.appReducer.countryCode
});

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);
